module.exports = __webpack_public_path__ + "static/media/CyberLogovo_6.7948cc0d.jpg";